import { useCallback } from "react";
import { Input } from "@wac-ui-dashboard/wac_component_library";
import Style from "../../../../Employees/Delivery/EditPrint/editPrint.module.scss";

const ItemFields = ({ formik, fieldIndex, canRemove }) => {
  const handleRemoveField = useCallback(() => {
    const data = formik.values.item_fields
      .filter((_, index) => index !== fieldIndex)
      .map((item, index) => ({ ...item, serial_number: index + 1 }));
    formik.setFieldValue("item_fields", data);
  }, [formik, fieldIndex]);

  const touched = formik.touched?.item_fields?.[fieldIndex];
  const errors = formik.errors?.item_fields?.[fieldIndex];

  const getItemError = (field) =>
    touched?.[field] && errors?.[field] ? errors[field] : undefined;

  return (
    <div className={Style.formFields}>
      {canRemove && (
        <span
          className={`${Style.corner_button} btn-close`}
          onClick={handleRemoveField}
        ></span>
      )}
      <div className="row">
        <div className="input-wrap">
          <Input
            label={"Serial Number"}
            type="text"
            id={`serial_number_${fieldIndex}`}
            name="serial_number"
            className={`pro-input lg ${getItemError("serial_number") && "error"}`}
            {...formik.getFieldProps(
              `item_fields.${fieldIndex}.serial_number`,
            )}
            error={getItemError("serial_number")}
            errorMessage={getItemError("serial_number")}
          />
        </div>
        <div className="input-wrap">
          <Input
            label={"Description"}
            type="text"
            id={`description_${fieldIndex}`}
            name="description"
            className={`pro-input lg ${getItemError("description") && "error"}`}
            {...formik.getFieldProps(`item_fields.${fieldIndex}.description`)}
            error={getItemError("description")}
            errorMessage={getItemError("description")}
          />
        </div>
        <div className="col-6">
          <div className="input-wrap">
            <Input
              label={"Gross Weight"}
              type="text"
              id={`gross_weight_${fieldIndex}`}
              name="gross_weight"
              className={`pro-input lg ${getItemError("gross_weight") && "error"}`}
              {...formik.getFieldProps(
                `item_fields.${fieldIndex}.gross_weight`,
              )}
              error={getItemError("gross_weight")}
              errorMessage={getItemError("gross_weight")}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="input-wrap">
            <Input
              label={"Net Weight"}
              type="text"
              id={`net_weight_${fieldIndex}`}
              name="net_weight"
              className={`pro-input lg ${getItemError("net_weight") && "error"}`}
              {...formik.getFieldProps(
                `item_fields.${fieldIndex}.net_weight`,
              )}
              error={getItemError("net_weight")}
              errorMessage={getItemError("net_weight")}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="input-wrap">
            <Input
              label={"Diamond Weight"}
              type="text"
              id={`diamond_weight_${fieldIndex}`}
              name="diamond_weight"
              className={`pro-input lg ${getItemError("diamond_weight") && "error"}`}
              {...formik.getFieldProps(
                `item_fields.${fieldIndex}.diamond_weight`,
              )}
              error={getItemError("diamond_weight")}
              errorMessage={getItemError("diamond_weight")}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="input-wrap">
            <Input
              label={"Stone Weight"}
              type="text"
              id={`stone_weight_${fieldIndex}`}
              name="stone_weight"
              className={`pro-input lg ${getItemError("stone_weight") && "error"}`}
              {...formik.getFieldProps(
                `item_fields.${fieldIndex}.stone_weight`,
              )}
              error={getItemError("stone_weight")}
              errorMessage={getItemError("stone_weight")}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="input-wrap">
            <Input
              label={"SAC Code"}
              type="text"
              id={`sac_code_${fieldIndex}`}
              name="sac_code"
              className={`pro-input lg ${getItemError("sac_code") && "error"}`}
              {...formik.getFieldProps(`item_fields.${fieldIndex}.sac_code`)}
              error={getItemError("sac_code")}
              errorMessage={getItemError("sac_code")}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="input-wrap">
            <Input
              label={"Amount"}
              type="text"
              id={`amount_${fieldIndex}`}
              name="amount"
              className={`pro-input lg ${getItemError("amount") && "error"}`}
              {...formik.getFieldProps(`item_fields.${fieldIndex}.amount`)}
              error={getItemError("amount")}
              errorMessage={getItemError("amount")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemFields;
